import type { BoardStation } from './board-types'

const normalizeStationStatus = (status?: string) => {
    return status?.trim().toLowerCase() ?? ''
}

const NOTIFIABLE_STATION_STATUS = 'busy'

const getStationNotificationKey = (station: BoardStation, index: number) => {
    return String(station.station_id ?? station.id ?? station.display_order ?? index)
}

export const hasBoardStatusChange = (previous: BoardStation[], next: BoardStation[]) => {
    const previousStatuses = new Map(
        previous.map((station, index) => [
            getStationNotificationKey(station, index),
            normalizeStationStatus(station.status),
        ])
    )

    return next.some((station, index) => {
        const stationKey = getStationNotificationKey(station, index)

        if (!previousStatuses.has(stationKey)) {
            return false
        }

        const nextStatus = normalizeStationStatus(station.status)

        return (
            previousStatuses.get(stationKey) !== nextStatus &&
            nextStatus === NOTIFIABLE_STATION_STATUS
        )
    })
}
